const t = (name, label, extra = {}) => ({ name, label, required: true, ...extra });
const o = (name, label, extra = {}) => ({ name, label, required: false, ...extra });

export const PLAYER_FIELDS = [
  t("full_name", "Full name"),
  t("dob", "Date of birth", { type: "date" }),
  t("gender", "Gender", { type: "select", options: ["Male", "Female", "Other"] }),
  t("mobile", "Mobile number", { type: "tel", placeholder: "10-digit mobile", max: 20 }),
  t("email", "Email", { type: "email", max: 160 }),
  t("state", "State", { type: "select", options: ["Telangana", "Andhra Pradesh", "Other"] }),
  t("district", "District / city"),
  t("player_role", "Player role", { type: "select", options: ["Batter", "Bowler", "All-rounder", "Wicket-keeper"] }),
  t("batting_hand", "Batting hand", { type: "select", options: ["Right-hand", "Left-hand"] }),
  t("bowling_style", "Bowling style", { type: "select", options: ["Right-arm fast", "Right-arm medium", "Left-arm fast", "Left-arm medium", "Right-arm spin", "Left-arm spin", "Does not bowl"] }),
  t("photo_path", "Photograph", { type: "photo", uploadUrl: "/uploads/player-photo" }),
  t("experience", "Playing experience", { type: "textarea", placeholder: "Years played, level of tournaments, formats", max: 1000 }),
  o("current_team", "Current team / club", { full: true }),
  o("achievements", "Achievements", { type: "textarea" }),
  o("highlight_url", "Highlight video URL", { type: "url", placeholder: "https://", full: true, max: 400 }),
  t("emergency_name", "Emergency contact name"),
  t("emergency_phone", "Emergency contact mobile", { type: "tel", max: 20 }),
];

export const FRANCHISE_FIELDS = [
  t("name", "Name"),
  t("company", "Company / organisation"),
  t("designation", "Designation"),
  t("mobile", "Mobile", { type: "tel", max: 20 }),
  t("email", "Email", { type: "email", max: 160 }),
  t("city", "City"),
  t("state", "State"),
  t("territory", "Preferred franchise territory", { type: "select", options: ["Hyderabad / Telangana", "Amaravati / Andhra Pradesh", "Open to either"] }),
  t("investment_interest", "Investment interest", { type: "select", options: ["Full franchise ownership", "Co-ownership / consortium", "Strategic partnership", "Exploring options"], full: true }),
  t("business_background", "Business background", { type: "textarea" }),
  o("message", "Message", { type: "textarea" }),
];

export const SPONSOR_FIELDS = [
  t("brand_name", "Brand name"),
  t("contact_person", "Contact person"),
  t("designation", "Designation"),
  t("email", "Email", { type: "email", max: 160 }),
  t("mobile", "Mobile", { type: "tel", max: 20 }),
  t("business_category", "Business category"),
  t("sponsorship_interest", "Sponsorship interest", { type: "select", options: ["Title Sponsorship", "Associate Sponsorship", "Team Sponsorship", "Official Partner", "Venue Branding", "Digital Partnership", "Broadcast-linked Sponsorship", "Request Sponsorship Deck"] }),
  o("budget_range", "Budget range", { type: "select", options: ["Under ₹10 lakh", "₹10–25 lakh", "₹25–50 lakh", "₹50 lakh – ₹1 crore", "Above ₹1 crore", "Prefer to discuss"] }),
  o("website", "Website", { type: "url", placeholder: "https://", full: true, max: 300 }),
  t("objectives", "Marketing objectives", { type: "textarea" }),
  o("message", "Message", { type: "textarea" }),
];

export const MEDIA_FIELDS = [
  t("name", "Name"),
  t("organisation", "Media organisation"),
  t("designation", "Designation"),
  t("email", "Email", { type: "email", max: 160 }),
  t("mobile", "Mobile", { type: "tel", max: 20 }),
  t("enquiry_type", "Enquiry type", { type: "select", options: ["Broadcasting / OTT", "Media Rights", "Production & Distribution", "Press / Interview", "Media Accreditation", "Other"] }),
  t("message", "Message", { type: "textarea", max: 3000 }),
];

export const CONTACT_FIELDS = [
  t("name", "Name"),
  t("email", "Email", { type: "email", max: 160 }),
  t("mobile", "Mobile", { type: "tel", max: 20 }),
  t("subject", "Subject"),
  t("message", "Message", { type: "textarea", max: 3000 }),
];

export const CONSENT = "I agree that CGN Sports may store and use the information I have provided to respond to this enquiry, in line with the Privacy Policy.";
